import { ArrowBack, AttachFile, ExpandMore, Save } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Accordion, AccordionDetails, AccordionSummary, Button, Card, CardContent, CardHeader, FormControl, Grid, IconButton, Input, InputAdornment, InputLabel, TextField, Tooltip, Typography } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import axios from 'axios';
import { format } from 'date-fns';
import React, { useEffect, useState } from 'react'
import { Controller, useForm, useWatch } from 'react-hook-form';
import { useLocation, useNavigate, useOutletContext } from 'react-router-dom';
import Swal from 'sweetalert2';
import { AuthStore } from '../../../../../store/UserStore';
import { base_url } from '../../../../../utils/GlobalVariables';
import { CustomDescrypt } from '../../../../../utils/MyEncryption';

const FormAdendum = () => {
    const { setBreadcrumbItem } = useOutletContext();
    const location = useLocation();
    const encryptUser = localStorage.getItem('AuthPersist');
    const encryptUserJson = JSON.parse(encryptUser);
    const decryptedUser = encryptUserJson.state.user === null ? "" : JSON.parse(CustomDescrypt(encryptUserJson.state.user));
    const adendumState = location.state.adendum || null;
    const noKontrakState = location.state.no_kontrak || null;
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const logOut = AuthStore((state) => state.logOut);
    const { handleSubmit, control, getValues, setValue, register, reset } = useForm();
    const [noKontrak, setNoKontrak] = useState(null);
    const [adendum, setAdendum] = useState(null);
    const [src, setSrc] = useState("");

    const file = useWatch({
        control,
        name: 'file'
    })

    useEffect(() => {
        setBreadcrumbItem({ '/bnd': 'Home', '/bnd/kontrak': 'Kontrak', '': adendumState === null ? 'Tambah Adendum' : 'Edit Adendum' });

        if (noKontrakState !== null) {
            setNoKontrak(noKontrakState)
        }
        if (adendumState !== null) {
            setAdendum(adendumState)
            console.log(adendumState);
            if (adendum !== null) {
                setValue('no_adendum', adendum.no_adendum)
                setValue('tgl_adendum', adendum.tgl_adendum)
                setValue('jumlah_kontrak', adendum.jumlah_kontrak === null ? undefined : rP(adendum.jumlah_kontrak))
                setValue('tgl_mulai', adendum.tgl_mulai)
                setValue('tgl_selesai', adendum.tgl_selesai)
                console.log(getValues());
            }
            // setAdendum(adendumState)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [adendum]);

    useEffect(() => {
        if (getValues('file').length > 0) {
            setValue('file', getValues('file')[0])
        }
        console.log(file);
        console.log(getValues());

        if (adendumState === null) {
            if (getValues('file').length === 0) {
                setSrc("")
            }
            else {
                setSrc(URL.createObjectURL(getValues('file')))
            }
        }
        else {
            if (getValues('file').length === 0) {
                setSrc(base_url + '/uploads/' + decryptedUser.tahun_anggaran + '/' + decryptedUser.id_opd + '/kontrak/adendum/' + adendumState.file)
            }
            else {
                setSrc(URL.createObjectURL(getValues('file')))
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [file])

    const onSubmitForm = (data) => {
        let url = '';
        if (adendumState === null) {
            console.log('Submit');

            if (data.file.length === 0) {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Load file Adendum'
                })
                return
            }
            url = base_url + '/bnd/adendum/insert'
            data.no_kontrak = noKontrak
        }
        else {
            console.log('Update');
            url = base_url + '/bnd/adendum/update'
            data.no_kontrak = adendumState.no_kontrak
            data._method = 'PUT'
        }
        
        data.jumlah_kontrak === undefined && (data.jumlah_kontrak = "");
        console.log(data);
        setLoading(true);
        axios.post(
            url,
            data,
            {
                headers: {
                    'Authorization': `Bearer ${decryptedUser.token}`,
                    'content-type': 'multipart/form-data'
                }
            })
            .then((response) => {
                setLoading(false);

                Swal.fire({
                    icon: 'success',
                    title: 'Berhasil',
                    text: response.data.msg
                })
                reset();
                navigate(-1)
            })
            .catch((error) => {
                console.log(error);
                if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                    logOut();
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: error.response.status + ' ' + error.response.data.message
                    })
                }
                setLoading(false)
            })
    }

    const formatRupiah = (e) => {
        console.log(e.target.name);
        const nominal = e.target.value;
        const nominalz = nominal.replace(/\./g, '')
        const price = new Intl.NumberFormat('id-ID').format(nominalz);
        setValue(e.target.name, price)
    }

    const rP = (e) => {
        const cur = new Intl.NumberFormat("id-ID", {
            maximumFractionDigits: 0,
            minimumFractionDigits: 0
        }).format(e);
        return cur;
    }

    return (
        <Card>
            <CardHeader
                title={
                    <Typography variant='h5'>Kembali</Typography>
                }
                avatar={
                    <Tooltip title="Kembali">
                        <IconButton variant="outlined" onClick={() => {
                            navigate(-1)
                        }} color="error"><ArrowBack /></IconButton>
                    </Tooltip>
                }
            // subheader="September 14, 2016"
            />
            <CardContent>
                <form onSubmit={handleSubmit(onSubmitForm)}>
                    <Grid container spacing={4}>
                        <Grid item xs={12} md={6} sx={{ textAlign: "center" }}>
                            <Controller
                                name="no_adendum"
                                control={control}
                                // defaultValue={getValues('no_adendum')}
                                render={({ field: { onChange, value } }) => (
                                    <TextField
                                        required
                                        fullWidth
                                        id="standard-basic"
                                        label="Nomor Adendum"
                                        variant="standard"
                                        margin="normal"
                                        onChange={onChange}
                                        defaultValue={value}
                                        inputProps={{
                                            readOnly: (adendumState !== null)
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Controller
                                name="tgl_adendum"
                                control={control}
                                defaultValue={null}
                                inputFormat="yyyy-MM-dd"
                                render={({ field: { onChange, value }, fieldState: { invalid } }) => (
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            {...register('tgl_adendum', { required: true })}
                                            label="Tanggal Adendum"
                                            control={control}
                                            inputFormat="yyyy-MM-dd"
                                            value={value}
                                            onChange={(e) => onChange(format(new Date(e), "yyyy-MM-dd"))}
                                            renderInput={(params) =>
                                                <TextField
                                                    helperText={invalid ? 'Isi Tanggal Adendum' : null}
                                                    fullWidth
                                                    variant="standard"
                                                    sx={{ mt: 2 }}
                                                    {...params}
                                                    error={invalid}
                                                />
                                            }
                                        />
                                    </LocalizationProvider>
                                )}
                            />
                        </Grid>
                    </Grid>

                    <Grid container spacing={4}>
                        <Grid item xs={12} md={6} sx={{ textAlign: "center" }}>
                            <FormControl fullWidth sx={{ mt: 2 }} variant="standard">
                                <InputLabel htmlFor="standard-adornment-amount">Jumlah Kontrak</InputLabel>
                                <Controller
                                    name="jumlah_kontrak"
                                    control={control}
                                    render={({ field: { value = 0 } }) => (
                                        <Input
                                            name='jumlah_kontrak'
                                            fullWidth
                                            id="standard-adornment-amount"
                                            value={value}
                                            onChange={formatRupiah}
                                            startAdornment={<InputAdornment position="start">Rp</InputAdornment>}
                                            onKeyPress={(event) => {
                                                if (!/[0-9]/.test(event.key)) {
                                                    event.preventDefault();
                                                }
                                            }}
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={6}>
                                    <Controller
                                        name="tgl_mulai"
                                        control={control}
                                        defaultValue={null}
                                        inputFormat="yyyy-MM-dd"
                                        render={({ field: { onChange, value }, fieldState: { invalid } }) => (
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <DatePicker
                                                    {...register('tgl_mulai')}
                                                    label="Tanggal Mulai Pekerjaan"
                                                    control={control}
                                                    inputFormat="yyyy-MM-dd"
                                                    value={value}
                                                    onChange={(e) => onChange(format(new Date(e), "yyyy-MM-dd"))}
                                                    renderInput={(params) =>
                                                        <TextField
                                                            fullWidth
                                                            variant="standard"
                                                            sx={{ mt: 2 }}
                                                            {...params}
                                                        />
                                                    }
                                                />
                                            </LocalizationProvider>
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Controller
                                        name="tgl_selesai"
                                        control={control}
                                        defaultValue={null}
                                        inputFormat="yyyy-MM-dd"
                                        render={({ field: { onChange, value }, fieldState: { invalid } }) => (
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <DatePicker
                                                    {...register('tgl_mulai')}
                                                    label="Tanggal Selesai Pekerjaan"
                                                    control={control}
                                                    inputFormat="yyyy-MM-dd"
                                                    value={value}
                                                    onChange={(e) => onChange(format(new Date(e), "yyyy-MM-dd"))}
                                                    renderInput={(params) =>
                                                        <TextField
                                                            fullWidth
                                                            variant="standard"
                                                            sx={{ mt: 2 }}
                                                            {...params}
                                                        />
                                                    }
                                                />
                                            </LocalizationProvider>
                                        )}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} py={2} justifyContent="center">
                        <Grid item xs={"auto"} textAlign='center'>
                            <Button
                                variant="outlined"
                                component="label"
                                startIcon={<AttachFile />}
                            >
                                File Adendum
                                <input
                                    {...register('file')}
                                    hidden
                                    accept="application/pdf"
                                    type="file"
                                />
                            </Button>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} py={2} justifyContent="center">
                        <Grid item xs={12} md={9} sx={{ textAlign: "center" }}>
                            <Accordion>
                                <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" expandIcon={<ExpandMore />}>
                                    <Typography>File</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <iframe width='100%' height={700} title="Pdf" src={
                                        src
                                    } />
                                </AccordionDetails>
                            </Accordion>
                        </Grid>
                    </Grid>
                    {/* } */}

                    <Grid container spacing={2} py={2} justifyContent="flex-end">
                        <Grid item >
                            <LoadingButton
                                // onClick={pencairan === null ? submitForm : updateData}
                                loading={loading}
                                variant="contained"
                                margin="normal"
                                loadingPosition="start"
                                startIcon={<Save />}
                                type='submit'
                            >
                                {adendumState === null ? "Simpan" : "Update"}
                            </LoadingButton>
                        </Grid>
                    </Grid>
                </form>
            </CardContent>
        </Card>
    )
}

export default FormAdendum